import { render, staticRenderFns } from "./GestionTiempos.vue?vue&type=template&id=24bc61d7&scoped=true"
import script from "./GestionTiempos.vue?vue&type=script&lang=js"
export * from "./GestionTiempos.vue?vue&type=script&lang=js"
import style0 from "./GestionTiempos.vue?vue&type=style&index=0&id=24bc61d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc61d7",
  null
  
)

export default component.exports